// extracted by mini-css-extract-plugin
export default {"InfoContainer":"InfoContainer_InfoContainer__5uGM9"};